import React from 'react';
import { GridCellProps } from '@progress/kendo-react-grid';
import { BidDTO, BidOption } from '../../store/bid/types';
import { Select, SelectRadioButton } from '../ui';
import { useTranslation } from 'react-i18next';
import { can } from '../../helpers/permissions';

interface Props extends GridCellProps {
  bidOptionsById: { [key: number]: BidOption };
  createBid: (data: BidDTO) => void;
}

const BidCell: React.FC<Props> = (props) => {
  const { t, i18n } = useTranslation();
  const field = props.field || '';
  const value = props.dataItem[field] || '';
  const { bidable_id, conflict } = props.dataItem;

  const options = Object.values(props.bidOptionsById)
    .map((value) => ({ id: value.id.toString(), label: value.name }))
    .concat([{ id: '', label: t('None') }]);

  const handleChange = (newValue: string) => {
    if (newValue === value) return;
    const bidOptionId = parseInt(newValue) || null;
    props.createBid({ bidable_id, bid_option_id: bidOptionId });
  };

  return (
    <td
      colSpan={props.colSpan}
      className={props.className}
      role="gridcell"
      aria-colindex={props.ariaColumnIndex}
      aria-selected={props.isSelected}
      style={props.style}
    >
      {options.length > 4 ? (
        <Select disabled={!can('CAN_EDIT_BID') || conflict} value={value} options={options} onChange={handleChange} />
      ) : (
        <SelectRadioButton
          className={`flex flex-col ${!can('CAN_EDIT_BID') || conflict ? 'opacity-60' : ''}`}
          disabled={!can('CAN_EDIT_BID') || conflict}
          value={value}
          options={options}
          onChange={handleChange}
        />
      )}
    </td>
  );
};

export default BidCell;
